const formatSpeciality = (speciality) => {
  switch (speciality) {
    case 'general_clinic':
      return 'Clinica Geral';
    case 'physiotherapyst':
      return 'Fisioterapia';
    case 'nutritionist':
      return 'Nutrição';
    default:
      return '';
  }
};

const formatPersonType = (person_type) => {
  switch (person_type) {
    case 'nutritionist':
      return 'Nutricionista';
    case 'doctor':
      return 'Médico';
    case 'professional':
      return 'Profissional';
    default:
      return '';
  }
};

const selectOptions = (items, labelKey = 'name') => items.map(item => ({
  value: item.person_id || item.company_id,
  label: item[labelKey],
}));

const statusOptions = [
  { value: '', label: 'Selecione' },
  { value: 'scheduled', label: 'Agendado' },
  { value: 'confirmed', label: 'Confirmado' },
  { value: 'changed', label: 'Alterado' },
  { value: 'cancelled', label: 'Cancelado' },
];

const getCurrentDate = () => {
  const date = new Date();
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};


module.exports = {
  formatSpeciality,
  formatPersonType,
  selectOptions,
  statusOptions,
  getCurrentDate,
}